import type { Speicher } from './belegnummern';

/**
 * Gebuchte Module des Betriebs (Server: stamm.betrieb, GET /kassen/:id/status).
 * Die Kasse blendet nicht gebuchte Funktionen aus; der Server sperrt sie
 * zusätzlich. Für den Start ohne Netz merkt sich das Gerät den letzten Stand.
 */
export const MODULE = [
  'tische',
  'kuechenbons',
  'rechnungTeilen',
  'trinkgeld',
  'ausserHaus',
  'bediener',
  'lager',
  'etiketten',
  'gutscheine',
  'kunden',
  'kartenzahlung',
  'kundenanzeige',
  'termine',
  'lieferdienste',
  'pfand',
  'backoffice',
] as const;
export type Modul = (typeof MODULE)[number];
export type Module = Record<Modul, boolean>;

/** Alle Module (Vorgabe der Verkaufskomponente in Tests; der Server meldet den echten Stand). */
export const ALLE_MODULE: Module = Object.fromEntries(MODULE.map((m) => [m, true])) as Module;

/**
 * PB-13 H-4 (S4): Grundkasse – kein Zusatz- oder Paketmodul. Gilt, solange die Kasse den
 * Modulstand ihres Betriebs nicht kennt (noch nie vom Server geladen, gespeicherter Stand
 * unlesbar). Verkauf mit Barzahlung, Storno, Belege und Abschluss sind keine Module und
 * bleiben. Ein früher gespeicherter Stand gilt weiter (Start ohne Netz).
 */
export const GRUND_MODULE: Module = Object.fromEntries(MODULE.map((m) => [m, false])) as Module;

function schluessel(kassenId: string): string {
  return `bilanx.module.${kassenId}`;
}

/** Antwort des Servers lesen: fehlende Schlüssel aus, falls überhaupt ein Objekt kam. */
export function leseModule(roh: unknown): Module | null {
  if (typeof roh !== 'object' || roh === null) {
    return null;
  }
  const r = roh as Record<string, unknown>;
  return Object.fromEntries(MODULE.map((m) => [m, r[m] === true])) as Module;
}

export function ladeModule(speicher: Speicher, kassenId: string): Module {
  const roh = speicher.getItem(schluessel(kassenId));
  if (roh === null) {
    return GRUND_MODULE;
  }
  try {
    return leseModule(JSON.parse(roh)) ?? GRUND_MODULE;
  } catch {
    return GRUND_MODULE;
  }
}

export function speichereModule(speicher: Speicher, kassenId: string, module: Module): void {
  speicher.setItem(schluessel(kassenId), JSON.stringify(module));
}
